import React from 'react';
import { styled } from '@linaria/react';

import NumberIcon, {
  type Status,
} from '@/components/AnimatedIcons/NumberIcon';
import VisuallyHidden from '@/components/VisuallyHidden';

import CodeEditorContext from '../CodeEditorContext';
import ActionButton from './ActionButton';

const LineNumbersButton = ({
  accentColor,
}: {
  accentColor: string;
}) => {
  const { showLineNumbers, setShowLineNumbers } =
    React.useContext(CodeEditorContext);

  const [status, setStatus] = React.useState<Status>('idle');

  // Manual 'useBoop' logic, since I want to flip the status when the boop ends. If the user stops hovering over the button before the timeout fires, the timeout will be canceled by the cleanup fn.
  React.useEffect(() => {
    if (status !== 'booped') {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setStatus('hovering');
    }, 150);

    return () => {
      window.clearTimeout(timeoutId);
    };
  });

  return (
    <Wrapper
      title="Toggle line numbers"
      onClick={() => setShowLineNumbers(!showLineNumbers)}
      onMouseEnter={() => setStatus('booped')}
      onMouseLeave={() => setStatus('idle')}
      onMouseDown={() => setStatus('pressed')}
      onMouseUp={() => setStatus('hovering')}
    >
      <NumberIcon
        size={16}
        isEnabled={showLineNumbers}
        status={status}
        accentColor={accentColor}
      />
      <VisuallyHidden>
        {showLineNumbers ? 'Hide' : 'Show'} line numbers
      </VisuallyHidden>
    </Wrapper>
  );
};

const Wrapper = styled(ActionButton)`
  transform-origin: center center;
`;

export default LineNumbersButton;
